import { useSelector, useDispatch } from 'react-redux'
import config from 'app/config'
import {
    getAuthUser,
    isAuth,
    isLoading,
    currentUser,
    expireAt,
    isAuthorizedUser,
    logout as signout,
} from 'features/auth/authSlice'

export const useAuth = () => {
    const dispatch = useDispatch()
    const expireOn = useSelector(expireAt)
    const authUser = useSelector(currentUser)
    const isAuthorized = useSelector(isAuthorizedUser)
    const isAuthenticated = useSelector(isAuth)
    const isAuthenticating = useSelector(isLoading)

    const login = () => {
        window.location.href = `${config.API_BASE_URL}oauth/login`
    }

    const logout = () => dispatch(signout())

    const fetchUserData = () => dispatch(getAuthUser())

    return {
        authUser,
        isAuthorized,
        isAuthenticated,
        isAuthenticating,
        expireOn,
        login,
        logout,
        fetchUserData,
    }
}
